module.exports = __webpack_public_path__ + "pc/img/main-magazine-img-03.0f816b37.png";